type VersionedRun = { id: string; version: number; updated_at: string };

export const runKey = (ownerId: string | undefined, id: string) =>
  ["agent-run", ownerId, id] as const;

// Both HTTP and SSE publish complete snapshots. A late response must never
// replace a newer snapshot already received through the other transport.
export function newerRun<T extends { id: string; version: number }>(
  previous: T | undefined,
  incoming: T,
): T {
  return previous?.id === incoming.id && previous.version >= incoming.version
    ? previous
    : incoming;
}

export function mergeRunList<T extends VersionedRun>(
  previous: { items: T[] } | undefined,
  incoming: { items: T[] },
): { items: T[] } {
  const runs = new Map(previous?.items.map((run) => [run.id, run]));
  for (const run of incoming.items)
    runs.set(run.id, newerRun(runs.get(run.id), run));
  // The API lists the 200 most recently updated tasks and has no delete route.
  // Keep newly acknowledged tasks when a list request predates their creation.
  return {
    items: [...runs.values()]
      .sort((a, b) => Date.parse(b.updated_at) - Date.parse(a.updated_at))
      .slice(0, 200),
  };
}

export const cancelStorageKey = (
  ownerId: string,
  runId: string,
  latestInputId: string,
) => `mh-chat-cancel-${ownerId}-${runId}-${latestInputId}`;
